module.exports = "/static/assets/4d0fe43ca32b2e96afca682909802332.png";